import { comparisonData } from '@/mocks/content';

export default function ComparisonSection() {
  const renderStars = (count: number) => {
    return Array.from({ length: 5 }).map((_, i) => (
      <span key={i} className="w-4 h-4 flex items-center justify-center">
        <i className={`${i < count ? 'ri-star-fill text-yellow-500' : 'ri-star-line text-foreground-300'} text-sm`}></i>
      </span>
    ));
  };

  return (
    <section id="comparacao" className="relative w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block bg-accent-100 text-accent-700 text-xs font-semibold px-4 py-1.5 rounded-full mb-4">
            Comparação
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">
            CSSBuy é <span className="text-accent-500">Seguro?</span>
          </h2>
          <p className="text-foreground-600 mt-3 text-sm md:text-base max-w-xl mx-auto">
            Compare o CSSBuy com outras plataformas e veja por que ele é a melhor escolha
          </p>
        </div>

        {/* Comparison Cards */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {comparisonData.map((item) => (
            <div
              key={item.platform}
              className={`bg-background-100 rounded-2xl border p-5 md:p-6 flex flex-col items-center text-center transition-all duration-300 ${
                item.highlight
                  ? 'border-accent-300 ring-1 ring-accent-200'
                  : 'border-background-200/60'
              }`}
            >
              {item.highlight && (
                <span className="inline-block bg-accent-500 text-white text-[10px] font-bold px-3 py-1 rounded-full mb-3">
                  Melhor Escolha
                </span>
              )}
              <h3 className="text-foreground-950 font-bold text-base md:text-lg mb-4">{item.platform}</h3>

              <div className="flex flex-col gap-3 w-full">
                <div className="flex flex-col items-center gap-1">
                  <span className="text-foreground-500 text-xs">Facilidade</span>
                  <div className="flex gap-0.5">{renderStars(item.facilidade)}</div>
                </div>
                <div className="flex flex-col items-center gap-1">
                  <span className="text-foreground-500 text-xs">Preço</span>
                  <div className="flex gap-0.5">{renderStars(item.preco)}</div>
                </div>
                <div className="flex flex-col items-center gap-1">
                  <span className="text-foreground-500 text-xs">Frete</span>
                  <div className="flex gap-0.5">{renderStars(item.frete)}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Trust Features */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-10">
          {[
            { icon: 'ri-camera-line', title: 'QC Photos', desc: 'Fotos de qualidade antes do envio' },
            { icon: 'ri-shield-line', title: 'Buyer Protection', desc: 'Proteção total ao comprador' },
            { icon: 'ri-box-3-line', title: 'Parcel Insurance', desc: 'Seguro de encomendas incluído' },
            { icon: 'ri-refund-2-line', title: 'Refund System', desc: 'Sistema de reembolso garantido' },
          ].map((item, idx) => (
            <div key={idx} className="flex flex-col items-center text-center p-4">
              <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-50 mb-3">
                <i className={`${item.icon} text-accent-600 text-xl`}></i>
              </span>
              <h4 className="text-foreground-950 font-semibold text-sm">{item.title}</h4>
              <p className="text-foreground-500 text-xs mt-1">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}